import { getDefaultLanguage } from '../service/constants';

export const saveToLocalStorage = (state) => {
  try {
    const replacer = (key, value) => {
      if (typeof value === 'function') return undefined;
      return value;
    };

    const serializedState = JSON.stringify(state, replacer);
    localStorage.setItem('persistentState', serializedState);
  } catch (e) {
    console.warn(e);
  }
};

export const loadFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('persistentState');
    if (serializedState === null) return undefined;
    const state = JSON.parse(serializedState);

    const defaultLang = getDefaultLanguage();
    if (state?.auth?.translationKey && state.auth.translationKey !== defaultLang) {
      state.auth.translationKey = defaultLang;
    }

    return state;
  } catch (e) {
    console.warn(e);
    return undefined;
  }
};
